module.exports = __webpack_public_path__ + "static/media/eventlogo.a878e2d9.png";